import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { CategorieEntite } from '../entites/categorie';

@Injectable({ providedIn: 'root' })
export class CategorieService {

  private obtenirListeUrl = environment.apiBaseUrl + 'categorie';
  private obtenirUrl = environment.apiBaseUrl + 'categorie/{id}';
  private ajouterUrl = environment.apiBaseUrl + 'categorie';
  private modifierUrl = environment.apiBaseUrl + 'categorie/modifier';
  private supprimerUrl = environment.apiBaseUrl + 'categorie/{id}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router) { }

  public ObtenirListe(): Promise<ReponseBase<CategorieEntite[]>> {
    var p = this.http.get<ReponseBase<CategorieEntite[]>>(this.obtenirListeUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Obtenir(id: number): Promise<ReponseBase<CategorieEntite>> {
    var p = this.http.get<ReponseBase<CategorieEntite>>(this.obtenirUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Ajouter(categorie: CategorieEntite): Promise<ReponseBase<CategorieEntite>> {
    var p = this.http.post<ReponseBase<CategorieEntite>>(this.ajouterUrl, JSON.stringify(categorie), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Modifier(categorie: CategorieEntite): Promise<ReponseBase<CategorieEntite>> {
    var p = this.http.post<ReponseBase<CategorieEntite>>(this.modifierUrl, JSON.stringify(categorie), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}
